import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const getTypeInterviewLabel = (type, typesInterview) =>
  typesInterview?.[type] || display(type);

const getCategoryTitles = (categories) =>
  categories?.map((category) => category.title).filter(Boolean).join(', ') ||
  '';

export const getInterviewStorePoolViewSections = (
  t,
  item,
  { typesInterview } = {},
) => {
  if (!item?.id) {
    return [];
  }

  const fields = [
    { text: t('Titolo'), value: display(item.title) },
    {
      text: t('Outlet Village'),
      value: display(
        item['shopping_centers.title'] || item.shopping_center?.title,
      ),
    },
    {
      text: t('DATA INIZIO SONDAGGIO'),
      value: displayDate(item.date_from),
    },
    {
      text: t('DATA FINE SONDAGGIO'),
      value: displayDate(item.date_to),
    },
    {
      text: t('DESTINATARI'),
      value: getTypeInterviewLabel(item.type_interview, typesInterview),
    },
    {
      text: t('Insegne/clienti che hanno risposto'),
      value: display(item.interview_store_pool_answers_size),
    },
  ];

  if (item.type_interview === 'type_interview_company') {
    fields.push(
      {
        text: t('SELEZIONA LE CATEGORIE STORES A CUI APRIRE IL SONDAGGIO'),
        value: display(getCategoryTitles(item.company_category_questions)),
      },
      {
        text: t('Pubblicazione su Telegram'),
        value: displayBool(item.in_telegram, t),
      },
    );
  }

  fields.push({
    text: t('SELEZIONE CATEGORIE STORES SU CUI EFFETTUARE IL SONDAGGIO'),
    value: display(getCategoryTitles(item.company_category_answers)),
  });

  return [
    {
      title: t('Informazioni Generali'),
      fields,
    },
  ];
};
